import Box from '@mui/material/Box';
import Shimmer from './Shimmer';

// Skeleton for the Branches list column.
//
// Rebuilt for v5. The old version drew a card grid with a 140px mint
// gradient banner on top of each card, from the previous design — the
// page is now a single vertical list beside a sticky detail panel, so
// the skeleton flashed a layout that no longer exists and then snapped.
//
// Mirrors the real card: white, 24px radius, 20px padding, name over
// address over an hours line, with the two pills that only appear on
// some branches left out.

const CARD_COUNT = 5;

const CentreCardShimmer = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 1.25,
      p: '20px',
      borderRadius: '24px',
      bgcolor: '#FFFFFF',
      border: '2px solid #FFFFFF',
    }}
  >
    {/* name + city pill */}
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: 1.25 }}>
      <Shimmer width="52%" height={18} rounded={6} />
      <Shimmer width={74} height={22} rounded={999} />
    </Box>
    {/* address, two lines */}
    <Shimmer width="100%" height={13} rounded={6} />
    <Shimmer width="78%" height={13} rounded={6} />
    {/* hours */}
    <Shimmer width="40%" height={14} rounded={6} />
  </Box>
);

const CentresShimmer = () => (
  <>
    {/* the "N locations" count line */}
    <Box sx={{ px: 1 }}>
      <Shimmer width={92} height={14} rounded={6} />
    </Box>
    {Array.from({ length: CARD_COUNT }, (_, i) => <CentreCardShimmer key={i} />)}
  </>
);

export default CentresShimmer;
